import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { roomsClient } from "./roomsClient";

export const roomsKeys = {
  /** Prefix for invalidating every rooms query. */
  all: ["rooms"] as const,
  list: (sessionKey: string, active?: boolean) =>
    ["rooms", sessionKey, active ?? "all"] as const,
};

/** Shared options for the rooms list, so the suspense grid and a non-suspense
 * reader (e.g. the derived active subject) hit the exact same cache entry. */
const roomsListQueryOptions = (sessionKey: string, active?: boolean) => ({
  queryKey: roomsKeys.list(sessionKey, active),
  queryFn: () =>
    roomsClient.list(active === undefined ? undefined : { active }),
});

export const useRoomsList = (sessionKey: string, active?: boolean) =>
  useSuspenseQuery(roomsListQueryOptions(sessionKey, active));

/**
 * Non-suspense read of the same rooms list, gated by `enabled`. Used outside
 * the workspace's AsyncBoundary (useActiveSubject) so a room lookup never
 * suspends or fetches when the current selection doesn't need it.
 */
export const useRoomsListQuery = (
  sessionKey: string,
  active: boolean | undefined,
  enabled: boolean,
) => useQuery({ ...roomsListQueryOptions(sessionKey, active), enabled });
